// extracted by mini-css-extract-plugin
module.exports = {"container":"LandingPage_container__2e1Ue","welcome":"LandingPage_welcome__3e4Fs","h4":"LandingPage_h4__1IgGm","btn":"LandingPage_btn__yfylP"};